import React, { useRef } from "react";
import styled from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const FAQ_DATA = [
  {
    q: "Gibt es nach der Behandlung Ausfallzeiten?",
    a: "Die meisten unserer Laser- und Filler-Behandlungen ermöglichen es Ihnen, sofort in Ihren Alltag zurückzukehren. Leichte Rötungen können auftreten, klingen jedoch in der Regel innerhalb weniger Stunden ab.",
  },
  {
    q: "Wie lange halten die Ergebnisse in der Regel an?",
    a: "Die Dauer variiert je nach Behandlung. Filler halten typischerweise 6–12 Monate, während Ergebnisse zur Hautverjüngung bei entsprechender Pflege dauerhaft sein können.",
  },
  {
    q: "Sind die Eingriffe schmerzhaft?",
    a: "Ihr Wohlbefinden steht bei uns an erster Stelle. Wir verwenden medizinische Anästhesiecremes und modernste Kühlungstechnologien, damit sich die meisten Behandlungen lediglich wie ein leichtes Prickeln anfühlen.",
  },
  {
    q: "Wann sind die ersten Veränderungen sichtbar?",
    a: "Bei Fillern sind die Ergebnisse sofort sichtbar. Bei Lasertherapien und Skinboostern bemerken Sie innerhalb von 48 Stunden ein „Strahlen“, wobei das finale Ergebnis nach etwa 2 Wochen erreicht ist.",
  },
];

const ModernFAQ = () => {
  const container = useRef();

  useGSAP(
    () => {
      const items = gsap.utils.toArray(".faq-item");

      items.forEach((item) => {
        const answer = item.querySelector(".faq-answer");
        const question = item.querySelector(".faq-question");

        // Spotlight Effect: Active question grows and becomes bright white
        gsap.fromTo(
          item,
          { opacity: 0.1, scale: 0.9, filter: "blur(2px)" },
          {
            opacity: 1,
            scale: 1.05,
            filter: "blur(0px)",
            scrollTrigger: {
              trigger: item,
              start: "top 60%",
              end: "top 40%",
              scrub: 0.5,
              onEnter: () =>
                gsap.to(answer, { height: "auto", opacity: 1, marginTop: 20 }),
              onLeave: () =>
                gsap.to(answer, { height: 0, opacity: 0, marginTop: 0 }),
              onEnterBack: () =>
                gsap.to(answer, { height: "auto", opacity: 1, marginTop: 20 }),
              onLeaveBack: () =>
                gsap.to(answer, { height: 0, opacity: 0, marginTop: 0 }),
            },
          },
        );
      });
    },
    { scope: container },
  );

  const scrollToQuestion = (index) => {
    const items = gsap.utils.toArray(".faq-item");
    gsap.to(window, {
      duration: 1.2,
      scrollTo: { y: items[index], offsetY: window.innerHeight / 2 - 50 },
      ease: "power4.inOut",
    });
  };

  return (
    <SectionWrapper ref={container}>
      <Header>
        <span className="label">Informationen</span>
        <h2>Häufige Fragen</h2>
      </Header>

      <ListWrapper>
        {FAQ_DATA.map((item, i) => (
          <FAQItem
            key={i}
            className="faq-item"
            onClick={() => scrollToQuestion(i)}
          >
            <Question className="faq-question">{item.q}</Question>
            <AnswerWrapper className="faq-answer">
              <Answer>{item.a}</Answer>
            </AnswerWrapper>
          </FAQItem>
        ))}
      </ListWrapper>
    </SectionWrapper>
  );
};

export default ModernFAQ;

// --- Styled Components ---

const SectionWrapper = styled.section`
  /* background-color: #050505; */
  /* color: #fff; */
  min-height: 100vh;
  padding: 15vh 10% 0 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 10vh;

  .label {
    text-transform: uppercase;
    letter-spacing: 0.5rem;
    font-size: 0.75rem;
    color: #d4af37;
    margin-bottom: 1rem;
    display: block;
  }

  h2 {
    font-family: "Playfair Display", serif;
    font-size: clamp(2rem, 5vw, 4rem);
    font-weight: 400;
  }
`;

const ListWrapper = styled.div`
  width: 100%;
  max-width: 900px;
`;

const FAQItem = styled.div`
  padding: 3rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: border-color 0.5s ease;

  &:hover {
    border-color: rgba(212, 175, 55, 0.3);
  }
`;

const Question = styled.h3`
  font-family: "Playfair Display", serif;
  font-size: clamp(1.5rem, 3.5vw, 2.8rem);
  font-weight: 400;
  line-height: 1.2;
  transition: color 0.3s ease;
`;

const AnswerWrapper = styled.div`
  height: 0;
  overflow: hidden;
  opacity: 0;
  display: flex;
  justify-content: center;
`;

const Answer = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  /* color: rgba(255, 255, 255, 0.5); */
  max-width: 600px;
`;
